import React from "react";
import { store, currentStore, currentMobileStore } from "../../config/config.js";

let BuyButton = React.createClass({
    getInitialState() {
        return {
            info: store[currentStore] || store.shopify,
            mobileInfo: store[currentMobileStore] || store.shopify
        };
    },
    render() {
        const { info, mobileInfo } = this.state;

        return (
          <span>
              <a {...(info.props || {})} className={`eo-buy-btn eo-btn btn-buy desktop ${this.props.className}`} href={info.url}
                                         onClick={this.closeMenu}>{info.copy}</a>
              <a {...(mobileInfo.props || {})} className={`eo-buy-btn eo-btn btn-buy mobile ${this.props.className}`} href={mobileInfo.url}
                                               onClick={this.closeMenu}>{mobileInfo.copy}</a>
          </span>
        );
    }
});

export default BuyButton;



/** WEBPACK FOOTER **
 ** ./app/views/components/BuyButton.js
 **/